import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5 group">
          <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg leading-none">
            茄
          </span>
          <span className="font-heading text-lg tracking-wide text-foreground-950 whitespace-nowrap">
            茄子视频
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm text-foreground-700 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#entry"
            className="px-4 py-2 rounded-md text-sm bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            前往下载入口
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800 text-xl"
        >
          <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="py-2 text-sm text-foreground-700 hover:text-primary-700 transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#entry"
            onClick={() => setOpen(false)}
            className="mt-1 py-2.5 rounded-md text-center text-sm bg-primary-500 text-background-50"
          >
            前往下载入口
          </a>
        </div>
      )}
    </header>
  );
}